<template>
  <div class="text-center padding-xl">
     <div class="f-frame">
        <div class="f-content" id="maincontain">
          <div class="f-sys">
            <img :src="require('../assets/bmkx/kefu.png')" class="f-icon"/>
            <div class="sys-talk">
              <div class="f-name">服务助手</div>
              <div class="f-mes">
                <div class="title-main">Hi，欢迎使用在线答疑服务。</div>
                <div class="title-sub"></div>
                <div v-for="(q,i) in qs" :key="i">
                   <div class="f-q" @click="send(q.id)">
                       {{q.faqTitle}}
                   </div>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(t,i) in ts" :key="i">
             <div v-if="t.type === 0" class="f-sys">
               <img :src="require('../assets/bmkx/kefu.png')" class="f-icon"/>
               <div class="sys-talk">
                   <div class="f-name">{{t.name}}</div>
                   <div class="f-mes">{{t.mes}}</div>
               </div>
             </div>
              <div v-if="t.type === 1" class="f-you">
                <img :src="require('../assets/bmkx/ziji.png')" class="f-icon"/>
                <div class="you-talk">
                  <div class="f-name">{{t.name}}</div>
                  <div class="f-mes">{{t.mes}}</div>
                </div>
              </div>
          </div>
        </div>
        <div class="f-operate">
          <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入疑问"
              v-model="inputMes">
          </el-input>
          <div class="send-btn" @click="send('')" @keyup.enter="keyDown($event)">发送</div>
        </div>
     </div>
  </div>
</template>

<script>
import bs from '@/services/data/bs'
export default {
  data () {
    return {
      user: {},
      inputMes: '',
      ts: [],
      qs: []

    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getFaqs()
  },
  mounted () {
    // 绑定监听事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed () {
    // 销毁事件
    window.addEventListener('keydown', this.keyDown)
  },
  methods: {
    send (id) {
      if (!id && !this.inputMes) {
        this.$message.error('请输入您的疑问')
        return
      }
      let sysMes = ''
      let youMes = ''
      if (id) {
        this.qs.some((q, i) => {
          if (q.id === id) {
            youMes = q.faqTitle
            sysMes = q.faqContent
            return true
          }
        })
      } else {
        youMes = this.inputMes
        this.qs.some((q, i) => {
          q.keyValue.split('#').some((k) => {
            if (youMes.includes(k)) {
              sysMes = q.faqContent
              return true
            }
          })
        })
      }
      this.ts.push({
        type: 1,
        name: '我',
        mes: youMes
      })
      this.ts.push({
        type: 0,
        name: '服务助手',
        mes: sysMes || '请联系工作人员010-55622660'
      })
      this.gotoBottom()
      this.inputMes = ''
    },
    getFaqs () {
      bs.data.faqs((res) => {
        if (res.code === 200) {
          this.qs = res.data
        }
      })
    },
    keyDown (e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.key === 'Enter') {
        this.send() // 定义的登录方法 ...............
        e.preventDefault() // 去掉默认的换行
      }
    }
  }
}
</script>
<style>
.el-textarea__inner:focus{
  border-color: #c11c20;
}
</style>
<style scoped>
.f-content{
  height: 260px;
  background-color: #ffffff;
  overflow-y: scroll;
}
.f-operate{
  border-top: 1px solid #c11c20;
  height: 104px;
}
.f-frame{
  border: 1px solid #c11c20;
  width: 100%;
  height: 380px;
}
::v-deep .el-textarea__inner, ::v-deep .el-input__inner {
  border-radius: 0 !important; /* 将圆角设置为0 */
}
.send-btn{
  background-color: #c11c20;
  color: #ffffff;
  font-weight: bold;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  width: 100%;
  border: 2px solid #c11c20;
  margin-left: -2px;
  cursor: pointer;
}
.send-btn:hover{
  background-color: #a52023;
  color: #f8b1b0;
}
.f-content{
  padding: 14px;
}
.f-sys{
  display: flex;
  width: 100%;
  margin-top: 10px;
}
.f-you{
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.f-name{
  font-size: 14px;
  font-weight: bold;
  color: #727272;
  margin: 4px;
  padding: 4px;
  margin-top: -10px;
}
.f-mes{
  font-size: 12px;
  margin: 4px;
  width: 100%;
  background-color: #fdf7f8;
  border-radius: 4px;
  padding: 10px;
  word-break: break-all;
}
.title-main{
  font-weight: bold;
}
.title-sub{
  font-size: 14px;
  color: #5F5F5F;
}
.f-icon{
  height: 30px;
  width: 30px;
}
.f-name{
  font-size: 14px;
  text-align: left;
}
.f-q{
  text-align: left;
  background-color: #ffffff;
  margin: 8px 4px;
  border-radius: 4px;
  padding: 4px 8px;
  color: #929292;
  cursor: pointer;
}
.f-q:hover{
  background-color: #f8b1b0;
  color: #000000;
}
.you-talk{
  display: flex;
  justify-content: flex-end;
  max-width: 70%;
}
.sys-talk{
  max-width: 70%;
}
/* 滚动条的宽度 */
::-webkit-scrollbar {
  width: 4px;
  height: 12px;
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #ffffff;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #f8b1b0;
  border-radius: 8px;
}

/* 鼠标悬浮在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #a52023;
}
</style>
